export default "__VITE_ASSET__l9Rwa8gt__"